import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
    const location = useLocation();
    const isHome = location.pathname === "/";
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <nav
  className={`flex justify-between items-center px-10 py-6 absolute w-full z-10 
  ${isHome ? "text-white" : "text-black bg-white backdrop-blur-sm"}`}
>
            <Link to="/" className="text-xl font-semibold tracking-wide">
                MSilverio Agency
            </Link>

            {/* Desktop */}
            <div className="hidden md:flex gap-10 items-center text-sm">
                <Link
                    to="/services"
                    className={`transition-colors duration-200 ${location.pathname === '/services' ? 'underline font-bold' : ''}`}
                >
                    Services
                </Link>
                <Link
                    to="/portfolio"
                    className={`transition-colors duration-200 ${location.pathname === '/portfolio' ? 'underline font-bold' : ''}`}
                >
                    Portfolio
                </Link>
                <Link
                    to="/contact"
                    className="bg-white text-black px-5 py-2 rounded-full flex items-center gap-2"
                >
                    Travaillons ensemble
                </Link>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden flex items-center">
                <button
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    className="focus:outline-none"
                    aria-label="Toggle mobile menu"
                >
                    <span className="text-2xl">{isMobileMenuOpen ? '✕' : '☰'}</span>
                </button>
            </div>

            {/* Mobile menu */}
            {isMobileMenuOpen && (
                <div className="absolute top-full left-0 w-full bg-black bg-opacity-90 text-white flex flex-col items-center py-8 gap-6 md:hidden z-20">
                    <Link
                        to="/services"
                        onClick={() => setIsMobileMenuOpen(false)}
                        className={`text-lg ${location.pathname === '/services' ? 'underline font-bold' : ''}`}
                    >
                        Services
                    </Link>
                    <Link
                        to="/portfolio"
                        onClick={() => setIsMobileMenuOpen(false)}
                        className={`text-lg ${location.pathname === '/portfolio' ? 'underline font-bold' : ''}`}
                    >
                        Portfolio
                    </Link>
                    <Link
                        to="/contact"
                        onClick={() => setIsMobileMenuOpen(false)}
                        className={`text-lg ${location.pathname === '/contact' ? 'underline font-bold' : ''}`}
                    >
                        Contact
                    </Link>
                    <Link
                        to="/contact"
                        onClick={() => setIsMobileMenuOpen(false)}
                        className="bg-white text-black px-5 py-2 rounded-full flex items-center gap-2"
                    >
                        Travaillons ensemble
                    </Link>
                </div>
            )}
        </nav>
    );
};

export default Navigation;